<div class="grid">
  <div style="position: absolute; top: 0; left: 0; width: 100%; background-color: rgba(244,244,244,0.8); z-index: -1"></div>

  <div class="col-12 mb-2">
    <div class="card title-card p-0 pt-3">
      <div class="flex justify-content-between pl-3 pr-3" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-user title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.account' | transloco}}</p>
            <p>{{'menu.descriptions.account' | transloco}}</p>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <p-tabMenu #tab (click)="activateMenu(tab)" *ngIf="tabsVisible" [activeItem]="activeItem"
                   [model]="items" class="hidden xl:inline"></p-tabMenu>

        <p-tabMenu #tab (click)="activateMenu(tab)" *ngIf="tabsVisible" [activeItem]="activeItem"
                   [model]="items" class="xl:hidden">
          <ng-template let-i="index" let-item pTemplate="item">
            <i [className]="item.icon"></i>
          </ng-template>
        </p-tabMenu>
      </div>
    </div>
    <div>
      <app-account-details *ngIf="activeItem.id == 'details'"></app-account-details>
      <app-account-subscriptions *ngIf="activeItem.id == 'subscriptions'"></app-account-subscriptions>
      <app-account-faqs *ngIf="activeItem.id == 'faqs'"></app-account-faqs>
      <app-account-user-guide *ngIf="activeItem.id == 'user-guide'"></app-account-user-guide>
    </div>
  </div>
</div>
